<style lang="less" scoped>
.individualDetails {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  text-align: left;
  .roof {
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: left;
    padding-left: 20px;
    box-sizing: border-box;
    background-color: #21aaff;
    font-size: 30px;
    color: #fff;
    display: flex;
    align-items: center;
    svg {
      margin-right: 20px;
    }
  }
  .item {
    width: 100%;
    margin-top: 20px;
    background-color: #fff;
    padding: 22px;
    box-sizing: border-box;
    overflow: hidden;
    .title {
      width: 100%;
      color: rgba(16, 16, 16, 1);
      font-size: 32px;
      margin-bottom: 40px;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        width: 6px;
        height: 36px;
        background-color: #1ea7ff;
        margin-right: 16px;
      }
    }
    .text {
      width: 100%;
      line-height: 40px;
      color: rgba(125, 121, 121, 1);
      font-size: 28px;
      img {
        display: block;
        width: 100%;
        margin-top: 28px;
        background-color: #f2f2f2;
      }
    }
    .list {
      width: 50%;
      float: left;
      margin-bottom: 14px;
      .name {
        width: 90%;
        margin: 0 auto;
        color: rgba(125, 121, 121, 1);
        font-size: 28px;
        margin-bottom: 14px;
      }
      img {
        display: block;
        width: 90%;
        height: 160px;
        margin: 0 auto;
        background-color: #f2f2f2;
      }
    }
  }
}
</style>

<template>
  <div class="individualDetails">
    <div class="roof" @click="back">
      <svg
        t="1591005918644"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1100"
        width="20"
        height="20"
      >
        <path d="M511.609097 961.619254" p-id="1101" fill="#ffffff"></path>
        <path
          d="M360.749204 511.010463 360.749204 511.010463l382.080022-382.074905c14.762215-14.788821 14.762215-38.777165 0-53.585429-14.812357-14.788821-38.799678-14.788821-53.607942 0L283.415908 481.201553c-1.107217 0.867764-2.190899 1.824555-3.206018 2.843768-14.788821 14.808264-14.788821 38.795585 0 53.585429l408.226518 408.230612c14.808264 14.807241 38.795585 14.807241 53.584406 0 14.785751-14.767332 14.785751-38.754652 0-53.562916L360.749204 511.010463 360.749204 511.010463zM360.749204 511.010463"
          p-id="1102"
          fill="#ffffff"
        ></path></svg
      >个人信息
    </div>
    <div class="item">
      <div class="title"><span></span>个人信息</div>
      <div class="text">姓名：{{ individualObj.userName }}</div>
      <div class="text">身份证号：{{ individualObj.idNo }}</div>
    </div>
    <div class="item">
      <div class="title"><span></span>身份证照片</div>
      <div class="list">
        <div class="name">正面照：</div>
          <lazy-component>
        <img
          :src="individualObj.idNoFront"
          v-if="individualObj.idNoFront"
          alt=""
          @click="viewImg(individualObj.idNoFront)"
        />
          <img
          src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_383515910831670212020215324721idCodez.png"
          alt=""
          v-else
        />
         </lazy-component>
      </div>
      <div class="list">
        <div class="name">反面照：</div>
          <lazy-component>
        <img
          :src="individualObj.idNoBack"
          alt=""
          v-if="individualObj.idNoBack"
          @click="viewImg(individualObj.idNoBack)"
        />
         <img
          src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_1585159108359080520202153950805idCodeb.png"
          alt=""
          v-else
        />
           </lazy-component>
      </div>
    </div>
    <div class="item">
      <div class="title"><span></span>银行卡信息</div>
      <div class="text">卡号：{{ individualObj.bankNo }}</div>
      <div class="text">手机号：{{ individualObj.mobile }}</div>
    </div>
  </div>
</template>

<script>
import http from "../../api/index.js";
import config from "../../utils/config.js";

export default {
  data() {
    return {
      individualObj: {},
    };
  },
  mounted() {
    // let id = this.$route.query.id;
    // console.log(this.$route.query)
    this.saasorderbusinessmenPagePost();
  },
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    // 时间格式的转换
    Time(value) {
      var dateee = new Date(value).toJSON();
      var date = new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
      return date.split(" ")[0];
    },
    saasorderbusinessmenPagePost() {
      http.post(config.signInfo).then((e) => {
        // console.log(e,'个体户详情')
        if (e.code == 0) {
          this.individualObj = e.data;
        }
      });
    },
    viewImg(imgUrl) {
      //   console.log(imgUrl,'1111111');
      if (!imgUrl || imgUrl == "") {
        this.$toast.warn("还未上传");
        return;
      }
      this.$dialog({
        type: "image", //设置弹窗类型为”图片弹窗“
        link: "", //点击图片跳转的Url
        imgSrc: imgUrl, //图片Url
        onClickImageLink: function () {
          //图片点击事件，默认行为是跳转Url
          console.log(this); //this指向该Dialog实例
          return false; //返回false可阻止默认的链接跳转行为
        },
      });
    },
  },
  components: {},
};
</script>



// WEBPACK FOOTER //
// src/pages/individualDetails/index.vue